import { mapState } from 'vuex'
import UserPicker from '@/components/user/picker/UserPicker.vue'
import TextEditor from '@/components/common/texteditor/TextEditor.vue'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'

const defaultEl = {
  id: null,
  client: null,
  material_group: null,
  disabled: 0,
  comments: '',
  disable_reason_user: null,
  disable_reason_username: '',
  schedule_to_date_period_id: null
};

export default {
  name: 'AuditConfigEdit',
  data () {
    return {
      editEl: defaultEl,
      loading: false,
      manualUser: false
    }
  },
  components: {
    UserPicker,
    TextEditor,
    DatePeriodPicker
  },
  computed: {
    ...mapState(['config']),
    getTitle () {
      return this.$t('menu.audit-config.edit');
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    }
  },
  methods: {
    show (elData, matGroupId, client) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
        this.editEl.material_group_id = matGroupId;
      }
      if (client) {
        this.editEl.client = client;
      }
      this.editEl.material_group = this.$store.getters.getParamFromConfig('material_groups', this.editEl.material_group_id, 'code');
      this.manualUser = false;
      if (this.editEl.disable_reason_username && this.editEl.disable_reason_username.length > 0) {
        this.manualUser = true;
      }
      this.$refs['modal-window'].show();
    },
    save () {
      if (!this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
          if (this.editEl[key] && typeof (this.editEl[key]) === typeof {}) {
            reqData[key] = reqData[key].api_id;
          }
        }
        if (this.manualUser) {
          reqData.disable_reason_user = null;
        }
        const self = this;
        this.ApiRequest.request('audit/edit-config', this.ApiRequest.REQUEST_POST, { auditConfig: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
